import { CarouselItem } from '@/basic/ReoCarousel';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import type { IBanner, IBannerItem } from '../IComponent';
import handleUbbTextWithV2 from '@/utils/shared/handleUbbTextWithV2';
import { ReoButton } from '@/deps/basic';
import * as Utils from '@reolink-web/utils';

const BannerItem: React.FC<IBannerItem> = (props) => {
    const {
        screenWidth,
        data
    } = props;

    // 当前需要展示的图片
    const curImage = useMemo(() => data.images[screenWidth > 768 ? 'store-pc' : 'store-mobile'], [data.images, screenWidth]);

    const curVideo = useMemo(() => data.videos[screenWidth > 768 ? 'store-pc' : 'store-mobile'], [data.videos, screenWidth]);

    const curTitleOrDescription = useCallback((type: 'title' | 'description') => {
        const pc = {
            text: data.setting.pc[type].text || data.meta[type],
            color: data.setting.pc[type].color,
            param: type === 'description' ? data.setting.pc[type].param : '',
            paramColor: type === 'description' ? data.setting.pc[type].paramColor : ''
        };
        const mobile = {
            text: data.setting.mobile[type].text || data.meta[type],
            color: data.setting.mobile[type].color,
            param: type === 'description' ? data.setting.mobile[type].param : '',
            paramColor: type === 'description' ? data.setting.mobile[type].paramColor : ''
        };
        if (screenWidth >= 768) {
            return pc;
        }
        else {
            if (data.setting.mobileIsSame) {
                return pc;
            }
            else {
                return mobile;
            }
        }
    }, [data.meta, data.setting.mobile, data.setting.mobileIsSame, data.setting.pc, screenWidth]);

    const currentSetting = useMemo(() => {
        if (screenWidth >= 768) {
            return data.setting.pc;
        }
        else {
            if (data.setting.mobileIsSame) {
                return data.setting.pc;
            }
            else {
                return data.setting.mobile;
            }
        }
    }, [data.setting.mobile, data.setting.mobileIsSame, data.setting.pc, screenWidth]);

    const btnClick = useCallback((e: React.MouseEvent<HTMLButtonElement>, link: string) => {
        e.stopPropagation();
        Utils.CompatibleJump.compatibleJump(link, '_self');
    }, []);

    const handleDescAndNoteContent = useCallback(
        (content: IBanner['setting']['pc']['description']) =>
            handleUbbTextWithV2(content.text, { mode: 'inline' })
                .replace('${1}', `<span style="color: ${content.paramColor}">${content.param}</span>`)
        , []);

    const videoRef = useRef<HTMLVideoElement>(null);
    useEffect(() => {
        if (videoRef.current) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            videoRef.current.play();
        }

    }, []);

    return (
        <CarouselItem>
            <div
                className={ 'banner_section' }
            >
                {
                    curVideo ? (
                        <div className='banner-video-wrap'>
                            <div className='banner-video'>
                                <video
                                    ref={ videoRef }
                                    poster={ curImage }
                                    preload='none'
                                    loop={ true }
                                    muted={ true }
                                    playsInline={ true }
                                >
                                    <source
                                        src={ curVideo }
                                        type='video/mp4'
                                    />
                                </video>
                            </div>
                        </div>
                    )
                        : (
                            <img
                                src={ curImage }
                                alt={ curTitleOrDescription('title').text }
                            />
                        )
                }
                <div className={ 'section_wrap' }>
                    <div className={ 'section_inner' }>
                        <h2
                            style={{ 'color': curTitleOrDescription('title').color }}
                            dangerouslySetInnerHTML={{ __html: handleUbbTextWithV2(curTitleOrDescription('title').text, { mode: 'inline' }) }}
                        >
                        </h2>
                        <p
                            style={{ 'color': curTitleOrDescription('description').color }}
                            className={ 'desc' }
                            dangerouslySetInnerHTML={{ __html: handleDescAndNoteContent(curTitleOrDescription('description')) }}
                        >
                        </p>
                        <div className={ 'banner_btn_group' }>
                            {
                                currentSetting?.button?.length ? currentSetting.button.map(function(info) {
                                    return (
                                        info.text ? (
                                            <ReoButton
                                                key={ Utils.String.randomString(6) }
                                                color={ info.color }
                                                activeColor={ info.color }
                                                activeBackgroundColor={ info.backgroundColor }
                                                activeBorderColor={ info.backgroundColor }
                                                borderColor={ info.backgroundColor }
                                                backgroundColor={ info.backgroundColor }
                                                icon={ 'icon-co_right' }
                                                onClick={ (e) => { btnClick(e, info.link); } }
                                            >
                                                {info.text}
                                            </ReoButton>
                                        ) : null
                                    );
                                }) : null
                            }
                        </div>
                        {
                            currentSetting.note.text ? (
                                <p
                                    className={ 'owlbanner-note' }
                                    style={{ 'color': currentSetting.note.color }}
                                    dangerouslySetInnerHTML={{ __html: handleDescAndNoteContent(currentSetting.note) }}
                                >
                                </p>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </CarouselItem>
    );
};

export default BannerItem;
